
import {
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import _ from 'lodash';
import { CustomIcon } from 'modules/components/layer00';
import { StyledDisplayField } from 'modules/components/layer01';
import { WeatherMetric } from 'modules/components/layer05';
import { SaveWeatherModal } from 'modules/components/layer17';

import React, { useState } from 'react';



export type WeatherSummaryCardProps = {
  name?: string;
  weather: {
    id: string;
    condition: string;
    maxTemp: number;
    precipitationAmount: number;
    minTemp: number;
  };
  address?: string;
  numberOfIncidents: number;
  numberOfInspections: number;

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: WeatherSummaryCardProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <>
      {isVisible && (
        <SaveWeatherModal.FC
          id={props.weather.id ?? ''}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Stack
        direction='column'
        position='relative'
        rowGap='2rem'
        flex='1 1 0'
        paddingY='1rem'
        paddingX='2rem'
        borderRadius='1rem'
        border={`1px solid ${theme.palette.secondary.dark}`}
      >
        <IconButton
          sx={{
            position: 'absolute', right: '2rem'
          }}
          onClick={() => setIsVisible(() => true)}
        >
          <CustomIcon.large.FC
            icon='EDITALT'
            stroke={theme.palette.primary.main}
          />
        </IconButton>
        <Stack
          direction='row'
          justifyContent='center'
          divider={(
            <Divider
              variant='fullWidth'
              orientation='vertical'
            />
          )}
        >

          <WeatherMetric.FC
            title={props.weather.condition}
            subTitle='Weather'
          />
          <WeatherMetric.FC
            title={`${props.weather.maxTemp} F`}
            subTitle='Highest Temp.'
          />
          <WeatherMetric.FC
            title={`${props.weather.minTemp} F`}
            subTitle='Lowest Temp.'
          />
          <WeatherMetric.FC
            title={`${props.weather.precipitationAmount}`}
            subTitle='Precipitation Amount.'
          />
          <WeatherMetric.FC
            icon={(
              <CustomIcon.large.FC
                icon='ALERTTRIANGLE'
                stroke={theme.palette.error.main}
              />
            )}
            title={_.toString(props.numberOfIncidents)}
            subTitle='Accidents'
          />

          <WeatherMetric.FC
            icon={(
              <CustomIcon.large.FC
                icon='WOODWORK'
                stroke={theme.palette.primary.main}
              />
            )}
            title={_.toString(props.numberOfInspections)}
            subTitle='Inspections'
          />
        </Stack>
        <>
          <Stack
            direction='row'
            padding='.5rem'
            borderRadius='1rem'
            bgcolor={theme.palette.customGray.light}
            justifyContent='center'
            columnGap='2rem'
          >
            <StyledDisplayField.FC
              icon={(
                <CustomIcon.large.FC
                  icon='AREA'
                  stroke={theme.palette.primary.main}
                />
              )}
              label='Location'
            >
              <Typography
                variant='formInput'
              >
                {props.name}
              </Typography>
            </StyledDisplayField.FC>
            <StyledDisplayField.FC
              icon={(
                <CustomIcon.large.FC
                  icon='PIN'
                  stroke={theme.palette.primary.main}
                />
              )}
              label='Address'
            >
              <Typography
                variant='formInput'
              >
                {props.address}
              </Typography>
            </StyledDisplayField.FC>


          </Stack>
        </>

      </Stack>
    </>
  );
};
